import get from 'lodash/get';
import includes from 'lodash/includes';

import { graphQLEdClient } from '../../graphQLClients';

import { CreateItemGqlQuery } from '../../../../../types';

import { generateUuid } from '../../../../../utils/generateUuid';
import { getQueryName } from '../../../../../utils/getQueryName';
import { productionConsole } from '../../../../../utils/productionConsole';
import { errorMessageStatusOrErrorsIsIncorrect } from '../../reactQueryConstants';

interface CreateItemProps<CreateItemInput> {
  action: string;
  query: CreateItemGqlQuery;
  queryInput: CreateItemInput;
}

const successQueryStatuses = ['created', 'success'];

export function createEdItem<CreateItemInput, CreateItemResponse>({
  action,
  query,
  queryInput
}: CreateItemProps<CreateItemInput>) {
  const { rawName, name } = getQueryName(query, 'mutation');

  productionConsole(
    'log',
    'createEdItem',
    { action, queryInput },
    rawName,
    JSON.stringify(queryInput)
  );

  const requestId = generateUuid();

  graphQLEdClient.addQueryParams(name, requestId);

  return new Promise<CreateItemResponse>((resolve, reject) => {
    return graphQLEdClient
      .request<CreateItemResponse, CreateItemInput>(query, queryInput, {
        requestId
      })
      .then((response) => {
        if (includes(successQueryStatuses, get(response, `${action}.status`))) {
          return resolve(response);
        }

        const errors = get(response, `${action}.errors`);

        reject(errors ? errors : errorMessageStatusOrErrorsIsIncorrect);
      })
      .catch((reason) => reject(reason));
  });
}
